import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InputText from "../../components/Input/InputText";
import ErrorText from "../../components/Typography/ErrorText";
import LandingIntro from "./components/LandingIntro";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../hooks/useAuth";

function Login() {
  const Auth = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const INITIAL_LOGIN_OBJ = {
    password: "",
    username: "",
  };

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loginObj, setLoginObj] = useState(INITIAL_LOGIN_OBJ);

  const submitForm = async (e: FormEvent) => {
    e.preventDefault();
    setErrorMessage("");

    if (loginObj.username.trim() === "")
      return setErrorMessage("Username is required! (use any value)");
    if (loginObj.password.trim() === "")
      return setErrorMessage("Password is required! (use any value)");
    else {
      setLoading(true);
      try {
        await Auth.signIn({
          username: loginObj.username,
          password: loginObj.password,
        });
        setLoading(false);
        queryClient.invalidateQueries();
        navigate("/");
      } catch (err) {
        console.log(err);
        setLoading(false);
        setErrorMessage(
          "Error logging in. Please check your username/password.",
        );
      }
    }
  };

  const updateFormValue = ({ name, value }: { name: string; value: any }) => {
    setErrorMessage("");
    setLoginObj({ ...loginObj, [name]: value });
  };

  return (
    <div className="flex min-h-screen items-center bg-base-200">
      <div className="card mx-auto w-full max-w-5xl  shadow-xl">
        <div className="grid  grid-cols-1 rounded-xl  bg-base-100 md:grid-cols-2">
          <div className="">
            <LandingIntro />
          </div>
          <div className="px-10 py-24">
            <h2 className="mb-2 text-center text-2xl font-semibold">Login</h2>
            <form onSubmit={submitForm}>
              <div className="mb-4">
                <InputText
                  type="text"
                  name="username"
                  defaultValue={loginObj.username}
                  containerStyle="mt-4"
                  labelTitle="Username"
                  autoComplete="username"
                  updateFormValue={updateFormValue}
                />

                <InputText
                  defaultValue={loginObj.password}
                  name="password"
                  type="password"
                  containerStyle="mt-4"
                  labelTitle="Password"
                  autoComplete="current-password"
                  updateFormValue={updateFormValue}
                />
              </div>

              <div className="text-right text-primary">
                <Link to="/forgot-password">
                  <span className="inline-block  text-sm  transition duration-200 hover:cursor-pointer hover:text-primary hover:underline">
                    Forgot Password?
                  </span>
                </Link>
              </div>

              <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>
              <button
                type="submit"
                className={
                  "btn btn-primary mt-2 w-full" + (loading ? " loading" : "")
                }
              >
                Login
              </button>

              <div className="mt-4 text-center">
                Don't have an account yet?{" "}
                <Link to="/register">
                  <span className="  inline-block  transition duration-200 hover:cursor-pointer hover:text-primary hover:underline">
                    Register
                  </span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
